import { createContext } from 'react';

import { CountryState } from '../../@types/countryContext';
import { countries as defaultCountries, getDefaultCountry } from './Country';

export const initialState: CountryState = {
    countries: defaultCountries,
    country: getDefaultCountry(defaultCountries),
    updateCountry: () => {},
    updateCountries: () => {},
};

export const CountryStateContext = createContext(initialState);
